import Icon from '../components/Icon.vue'

Icon.register({
  'laugh-beam': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM272 207.4c-0.7 8.6 10.9 11.9 15.1 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6 12.3 0 23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4.1 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4zM112 207.4c-0.7 8.5 10.8 11.9 15.1 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6 12.3 0 23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4.1 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4zM398.9 306c1.2-9.6-6.3-18-15.9-18h-270c-9.6 0-17.1 8.5-15.9 18 8.9 71 69.5 126 142.9 126h16c73.4 0 134-55 142.9-126z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/laugh-beam.js
// module id = 1508
// module chunks = 0